// 点击后获取当前用户生成的绑定二维码
<template>
  <div class="qrcode-wrapper">
    <div class="qrbox" @click="visible = !visible">
      <svg-icon icon-class="wechat" class="qrcode-svg" slot="reference" />
      <span class="label">关注微信</span>
    </div>
    <el-popover
      trigger="hover"
      @show="handleFetchQrCode"
      v-model="visible"
      popper-class="qr-content-box"
    >
      <h3>请打开微信扫描下方二维码</h3>
      <el-skeleton :loading="!isInitial" animated>
        <template slot="template">
          <el-skeleton-item
            variant="image"
            style="width: 200px; height: 200px"
          />
        </template>
        <template>
          <div>
            <img style="width: 200px; height: 200px" :src="imageBase64" />
          </div>
        </template>
      </el-skeleton>

      <!-- <svg-icon icon-class="qrcode" class="qrcode-svg" slot="reference" /> -->
    </el-popover>
  </div>
</template>
<script>
import { fetchQrCode } from "@/api/qrcode";

export default {
  name: "QrCode",
  data() {
    return {
      imageBase64: "",
      isInitial: false,
      visible: false
    };
  },
  methods: {
    async handleFetchQrCode() {
      if (!this.isInitial) {
        const { data } = await fetchQrCode();
        this.imageBase64 = data;
        this.isInitial = true;
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.qrcode-wrapper {
  .qrbox{
    display: flex;
    align-items: center;
    height: 34px;
    box-sizing: border-box;
    background-color: #e9f5f3;
    padding: 0 15px;
    border-radius: 99px;
    min-width: 60px;
    cursor: pointer;
    &:hover{
      border-color: #159443;
    }
    .label {
      line-height: 1;
      font-size: 12px;
      color: #159443;
    }
    .qrcode-svg {
      height: 20px;
      width: 20px;
      margin-right: 6px;
    }
  }
}

@media (max-width:1366px) {
  .qrbox{
    padding: 0 6px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/QrCode.vue